import styled from "styled-components";
import React, {useEffect, useState} from "react";
import PilotsSearchBar from "../search-bar/by-pilot/PilotsSearchBar";
import {useDispatch, useSelector} from "react-redux";
import SmallCardProject from "../project/overview/SmallCardProject";
import {loadUsers} from "../user/usersAction";

const DashboardByUser = () => {

    const dispatch = useDispatch()
    const {users} = useSelector(state => state.users)
    const {projects} = useSelector(state => state.projects)
    const [pilotedProjects, setPilotedProjects] = useState([])
    const [coPilotedProjects, setCoPilotedProjects] = useState([])
    const [membersProjects, setMembersProjects] = useState([])
    const [selectedUser, setSelectedUser] = useState(0)

    useEffect(() => {
        dispatch(loadUsers())
    }, [dispatch])

    useEffect(() => {
        setPilotedProjects([])
        setCoPilotedProjects([])
        setMembersProjects([])
        projects.forEach((p) => {
            if (p.pilot.id === selectedUser) {
                setPilotedProjects(prevState => [...prevState, p])
            }
            if (p.coPilot?.id === selectedUser) {
                setCoPilotedProjects(prevState => [...prevState, p])
            }
            p.members.forEach((m) => {
                if (m.id === selectedUser) {
                    setMembersProjects(prevState => [...prevState, p])
                }
            })
        })
    }, [projects, selectedUser])


    return (
        <Container>
            <h2> Enjoy 360° collaborateurs </h2>
            <div>
                <p className={"txt-align"}> Analysez la répartition des rôles de chaque collaborateur au sein des
                    projets stratégiques : </p>
                <p className={"txt-align"}>pilote, copilote et membre d’une équipe projet.</p>
            </div>
            <ContainerSearchBar>
                <PilotsSearchBar
                    usersArray={users}
                    data={projects}
                    setData={setPilotedProjects}
                    setSelectedUser={setSelectedUser}
                    pilotHasToBeSet={true}
                />
            </ContainerSearchBar>

            <ProjectsContainer>
                <ProjectColumns>
                    <h2> Pilote ({pilotedProjects.length})</h2>
                    {pilotedProjects.map(p => (
                            <SmallCardProject
                                key={p.id + "-" + p.name}
                                projectId={p.id}
                                name={p.name}
                                pilot={p.pilot}
                                weather={p.weather}
                                advancement={p.advancement}
                                lastUpdate={p.lastUpdate}
                                endDate={p.endDate}
                                startDate={p.startDate}
                                confidential={p.confidential}
                            />
                        )
                    )}
                </ProjectColumns>
                <ProjectColumns>
                    <h2> Copilote ({coPilotedProjects.length}) </h2>
                    {coPilotedProjects.map(p => (
                            <SmallCardProject
                                key={p.id + "-" + p.name}
                                projectId={p.id}
                                name={p.name}
                                pilot={p.pilot}
                                weather={p.weather}
                                advancement={p.advancement}
                                lastUpdate={p.lastUpdate}
                                endDate={p.endDate}
                                startDate={p.startDate}
                                confidential={p.confidential}
                            />
                        )
                    )}
                </ProjectColumns>
                <ProjectColumns>
                    <h2> Membre ({membersProjects.length})</h2>
                    {membersProjects.map(p => (
                            <SmallCardProject
                                key={p.id + "-" + p.name}
                                projectId={p.id}
                                name={p.name}
                                pilot={p.pilot}
                                weather={p.weather}
                                advancement={p.advancement}
                                lastUpdate={p.lastUpdate}
                                endDate={p.endDate}
                                startDate={p.startDate}
                                confidential={p.confidential}
                            />
                        )
                    )}
                </ProjectColumns>
            </ProjectsContainer>
        </Container>
    )
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding-bottom: 1em;
  margin-bottom: 1rem;
  @media (min-width: 900px) {
    padding: 0 1rem 0 1rem;
  }
`
const ContainerSearchBar = styled.div`
  align-self: center;
  max-width: 370px;

  .search-bar-user {
    width: 100%
  }

  @media (min-width: 768px) {
    max-width: 760px;
  }
  @media (min-width: 1224px) {
    max-width: 1200px;
  }
`
const ProjectsContainer = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    margin-top: 1em;
  }

  @media (min-width: 1000px) {
    margin-top: 3em;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1em;
    h2 {
      margin-top: unset;
    }

    #roadmap-h1 {
      grid-column-start: 1;
      grid-column-end: span 3;
      justify-self: center;
    }
  }
`
const ProjectColumns = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
`

export default DashboardByUser;